import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/content';
export function TestimonialCard({
  t
}: {
  t: Testimonial;
}) {
  return <figure className="flex h-full min-w-[280px] flex-col rounded-r-lg border-l-[3px] border-orange bg-carbon-3 p-6 sm:min-w-0" data-id="element-222">
      <div className="flex items-center gap-3" data-id="element-223">
        <div className="flex h-12 w-12 flex-none items-center justify-center rounded-full border border-gold-tenue bg-carbon-2 font-heading font-bold text-gold" data-id="element-224">
          {t.initials}
        </div>
        <div className="flex" aria-label="5 de 5 estrellas" data-id="element-225">
          {Array.from({
          length: 5
        }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" data-id="element-226" />)}
        </div>
      </div>
      <blockquote className="mt-4 flex-1 text-base italic leading-relaxed text-muted" data-id="element-227">
        «{t.quote}»
      </blockquote>
      <figcaption className="mt-4 border-t border-gold-tenue pt-3" data-id="element-228">
        <span className="block font-heading font-bold text-soft" data-id="element-229">{t.name}</span>
        <span className="text-sm text-muted" data-id="element-230">{t.role}</span>
      </figcaption>
    </figure>;
}